import axiosInstance from '../variables/api/axiosInstance';

/**
 * Indexation GED - attendre qu'un document envoyé soit réellement consommé.
 *
 * La GED est un Paperless : elle indexe en asynchrone (OCR). Le backend attend
 * l'indexation quelques secondes seulement, puis rend la main avec le statut
 * `EN_COURS` et mémorise la tâche ; un planificateur la résout ensuite toutes
 * les 30 s. Sans ce module, l'écran ne l'apprend jamais et l'agent croit que
 * l'envoi a échoué - alors que le document finit bien par être associé.
 *
 * On sonde `/resoudre` plutôt que d'attendre plus longtemps côté serveur : la
 * requête d'envoi reste courte, et un fichier lent ne bloque pas la page.
 */

export const POLL_MAX = 15;        // 15 × 3 s = 45 s au plus
export const POLL_DELAI_MS = 3_000;

/** Le document est parti mais la GED ne l'a pas encore consommé. */
export const indexationEnCours = (doc) =>
  Boolean(doc?.ossanGedDocumentTrackingId) && doc?.gedIndexationStatut === 'EN_COURS';

/**
 * Sonde jusqu'à ce que la GED rende l'identifiant du document.
 * Rend l'identifiant, ou `null` si l'indexation dure au-delà de la fenêtre -
 * auquel cas le document n'est pas perdu : le planificateur le résoudra.
 */
export async function attendreIndexation(trackingId, options = {}) {
  const { max = POLL_MAX, delaiMs = POLL_DELAI_MS, surTentative } = options;
  for (let tentative = 1; tentative <= max; tentative++) {
    await new Promise((r) => setTimeout(r, delaiMs));
    if (surTentative) surTentative(tentative, max);
    try {
      const r = await axiosInstance.get(`/v1/ged/documents/${trackingId}/resoudre`);
      const id = r.data?.data?.ossanGedDocumentId;
      if (id) return id;
    } catch {
      // Erreur passagère : le planificateur repassera de toute façon, on continue.
    }
  }
  return null;
}
